const en = {
  nav: {
    login: "Login",
    home: "Home",
    admins: "Admins",
    events: "Events",
    documents: "Documents",
    visitors: "Visitors",
    partners: "Partners",
    duk: "DUK",
    information: "Information",
    catering: "Feeding",
    banners: "Banners",
  },
  descriptions: {
    welcomeToTwinsbet: "Welcome to Arena Vilnius",
    useTwinsBet:
      "Use Arena Vilnius opportunities and enjoy the event even more.",
    app: "MOBILE APP",
    food: "FOOD ORDERING",
    casino: "CASINO",
    useTheApp: "Use the arena app",
    foodDrinkMenu: "Food and drinks menu",
    allFunctions: "All arena functions in one place",
    orderQuickly: "Order conveniently and quickly",
    findLuck: "Gambling and slot machines",
    twinsBet: "www.arenavilnius.lt",
  },
};

export default en;
